'use client';

import type { ComponentProps } from 'react';

import Link from 'next/link';

type PublicLinkProps = ComponentProps<typeof Link>;

export function PublicLink({
  prefetch = false,
  ...props
}: PublicLinkProps) {
  return <Link prefetch={prefetch} {...props} />;
}
